export const provinces = [
  {
    code: 39,
    name: 'La Habana',
    city: [
      {
        code: 1023,
        name: 'Centro Habana',
      },
      {
        code: 1032,
        name: 'Plaza de la Revolucion',
      },
      {
        code: 1028,
        name: 'Diez de Octubre',
      },
      {
        code: 1025,
        name: 'La Lisa',
      },
      {
        code: 1026,
        name: 'Boyeros',
      },
      {
        code: 1029,
        name: 'Marianao',
      },
      {
        code: 1022,
        name: 'Regla',
      },
      {
        code: 1024,
        name: 'Playa',
      },
      {
        code: 1030,
        name: 'Habana Vieja',
      },
      {
        code: 1021,
        name: 'San Miguel del Padrón',
      },
      {
        code: 1027,
        name: 'Habana del Este',
      },
      {
        code: 1034,
        name: 'Cerro',
      },
      {
        code: 1031,
        name: 'Cotorro',
      },
      {
        code: 1033,
        name: 'Arroyo Naranjo',
      },
      {
        code: 1035,
        name: 'Guanabacoa',
      },
    ],
  },
  {
    code: 59,
    name: 'Mayabeque',
    city: [
      {
        code: 1150,
        name: 'Santa Cruz del Norte',
      },
      {
        code: 1149,
        name: 'Jaruco',
      },
      {
        code: 1130,
        name: 'Bejucal',
      },
      {
        code: 1154,
        name: 'Nueva Paz',
      },
      {
        code: 1151,
        name: 'San Nicolás',
      },
      {
        code: 1131,
        name: 'Quivicán',
      },
      {
        code: 1153,
        name: 'Güines',
      },
      {
        code: 1152,
        name: 'Melena del Sur',
      },
      {
        code: 1183,
        name: 'San José de las Lajas',
      },
      {
        code: 1178,
        name: 'Madruga',
      },
      {
        code: 1181,
        name: 'Batabanó',
      },
    ],
  },
  {
    code: 57,
    name: 'Camaguey',
    city: [
      {
        code: 1103,
        name: 'Sibanicú',
      },
      {
        code: 1102,
        name: 'Sierra de Cubitas',
      },
      {
        code: 1109,
        name: 'Guáimaro',
      },
      {
        code: 1108,
        name: 'Carlos Manuel de Cespedes',
      },
      {
        code: 1105,
        name: 'Vertientes',
      },
      {
        code: 1104,
        name: 'Florida',
      },
      {
        code: 1106,
        name: 'Minas',
      },
      {
        code: 1107,
        name: 'Jimaguayú',
      },
      {
        code: 1170,
        name: 'Santa Cruz del Sur',
      },
      {
        code: 1038,
        name: 'Nuevitas',
      },
      {
        code: 1171,
        name: 'Esmeralda',
      },
      {
        code: 1145,
        name: 'Camaguey',
      },
      {
        code: 1110,
        name: 'Najasa',
      },
    ],
  },
  {
    code: 52,
    name: 'Granma',
    city: [
      {
        code: 1113,
        name: 'Manzanillo',
      },
      {
        code: 1116,
        name: 'Bayamo',
      },
      {
        code: 1114,
        name: 'Campechuela',
      },
      {
        code: 1115,
        name: 'Niquero',
      },
      {
        code: 1112,
        name: 'Yara',
      },
      {
        code: 1122,
        name: 'Jiguaní',
      },
      {
        code: 1111,
        name: 'Bartolomé Masó',
      },
      {
        code: 1121,
        name: 'Buey Arriba',
      },
      {
        code: 1066,
        name: 'Río Cauto',
      },
      {
        code: 1119,
        name: 'Guisa',
      },
      {
        code: 1120,
        name: 'Cauto Cristo',
      },
      {
        code: 1118,
        name: 'Pilón',
      },
      {
        code: 1117,
        name: 'Media Luna',
      },
    ],
  },
  {
    code: 60,
    name: 'Cienfuegos',
    city: [
      {
        code: 1137,
        name: 'Abreus',
      },
      {
        code: 1140,
        name: 'Cruces',
      },
      {
        code: 1141,
        name: 'Palmira',
      },
      {
        code: 1138,
        name: 'Aguada de Pasajeros',
      },
      {
        code: 1139,
        name: 'Rodas',
      },
      {
        code: 1143,
        name: 'Lajas',
      },
      {
        code: 1142,
        name: 'Cumanayagua',
      },
      {
        code: 1164,
        name: 'Cienfuegos',
      },
    ],
  },
  {
    code: 55,
    name: 'Guantanamo',
    city: [
      {
        code: 1069,
        name: 'Maisí',
      },
      {
        code: 1070,
        name: 'Yateras',
      },
      {
        code: 1075,
        name: 'Manuel Tames',
      },
      {
        code: 1076,
        name: 'Baracoa',
      },
      {
        code: 1074,
        name: 'San Antonio del Sur',
      },
      {
        code: 1073,
        name: 'El Salvador',
      },
      {
        code: 1077,
        name: 'Niceto Pérez',
      },
      {
        code: 1071,
        name: 'Guantánamo',
      },
      {
        code: 1072,
        name: 'Imias',
      },
      {
        code: 1039,
        name: 'Caimanera',
      },
    ],
  },
  {
    code: 58,
    name: 'Pinar del Rio',
    city: [
      {
        code: 1124,
        name: 'Los Palacios',
      },
      {
        code: 1125,
        name: 'La Palma',
      },
      {
        code: 1165,
        name: 'Sandino',
      },
      {
        code: 1169,
        name: 'Viñales',
      },
      {
        code: 1182,
        name: 'Minas de Matahambre',
      },
      {
        code: 1187,
        name: 'San Luis',
      },
      {
        code: 1186,
        name: 'Mantua',
      },
      {
        code: 1188,
        name: 'Consolación del Sur',
      },
      {
        code: 1189,
        name: 'Pinar del Rio',
      },
      {
        code: 1132,
        name: 'Guane',
      },
      {
        code: 1133,
        name: 'San Juan y Martínez',
      },
    ],
  },
  {
    code: 54,
    name: 'Santiago de Cuba',
    city: [
      {
        code: 1068,
        name: 'Santiago de Cuba',
      },
      {
        code: 1078,
        name: 'Contramaestre',
      },
      {
        code: 1079,
        name: 'Mella',
      },
      {
        code: 1080,
        name: 'San Luis',
      },
      {
        code: 1083,
        name: 'Guamá',
      },
      {
        code: 1081,
        name: 'Segundo Frente',
      },
      {
        code: 1082,
        name: 'Tercer Frente',
      },
      {
        code: 1085,
        name: 'Songo La Maya',
      },
      {
        code: 1084,
        name: 'Palma Soriano',
      },
    ],
  },
  {
    code: 56,
    name: 'Las Tunas',
    city: [
      {
        code: 1101,
        name: 'Menéndez',
      },
      {
        code: 1099,
        name: 'Colombia',
      },
      {
        code: 1097,
        name: 'Las Tunas',
      },
      {
        code: 1100,
        name: 'Jobabo',
      },
      {
        code: 1172,
        name: 'Puerto Padre',
      },
      {
        code: 1174,
        name: 'Amancio',
      },
      {
        code: 1098,
        name: 'Majibacoa',
      },
      {
        code: 1173,
        name: 'Manatí',
      },
      {
        code: 212,
        name: 'Jesus Menendez',
      },
    ],
  },
  {
    code: 63,
    name: 'Ciego de Avila',
    city: [
      {
        code: 1155,
        name: 'Bolivia',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1156,
        name: 'Ciego de Avila',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1157,
        name: 'Ciro Redondo',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1158,
        name: 'Majagua',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1159,
        name: 'Florencia',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1160,
        name: 'Primero de Enero',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1162,
        name: 'Chambas',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1180,
        name: 'Venezuela',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1163,
        name: 'Baraguá',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
      {
        code: 1161,
        name: 'Morón',
        province: {
          name: 'Ciego de Avila',
          code: 63,
        },
      },
    ],
  },
  {
    code: 64,
    name: 'Artemisa',
    city: [
      {
        code: 1060,
        name: 'Caimito',
      },
      {
        code: 1123,
        name: 'Güira de Melena',
      },
      {
        code: 1126,
        name: 'Alquízar',
      },
      {
        code: 1127,
        name: 'Bahía Honda',
      },
      {
        code: 1128,
        name: 'San Antonio de los Baños',
      },
      {
        code: 1129,
        name: 'Bauta',
      },
      {
        code: 1134,
        name: 'Guanajay',
      },
      {
        code: 1136,
        name: 'Candelaria',
      },
      {
        code: 1144,
        name: 'Artemisa',
      },
      {
        code: 1135,
        name: 'San Cristóbal',
      },
      {
        code: 1177,
        name: 'Mariel',
      },
    ],
  },
  {
    code: 65,
    name: 'Villa Clara',
    city: [
      {
        code: 1045,
        name: 'Santa Clara',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1046,
        name: 'Cifuentes',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1047,
        name: 'Santo Domingo',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1048,
        name: 'Ranchuelo',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1049,
        name: 'Manicaragua',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1146,
        name: 'Quemado de Guines',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1166,
        name: 'Encrucijada',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1167,
        name: 'Corralillo',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1168,
        name: 'Sagua la Grande',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1042,
        name: 'Camajuaní',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1037,
        name: 'Caibarien',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1043,
        name: 'Remedios',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
      {
        code: 1044,
        name: 'Placetas',
        province: {
          name: 'Villa Clara',
          code: 65,
        },
      },
    ],
  },
  {
    code: 53,
    name: 'Holguín',
    city: [
      {
        code: 1086,
        name: 'Baguano',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1087,
        name: 'Cueto',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1088,
        name: 'Cacocum',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1089,
        name: 'Banes',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1090,
        name: 'Antilla',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1091,
        name: 'Rafael Freyre',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1093,
        name: 'Urbano Noris',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1094,
        name: 'Gibara',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1095,
        name: 'Frank Pais',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1096,
        name: 'Calixto Garcia',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1092,
        name: 'Holguín',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1175,
        name: 'Moa',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1176,
        name: 'Mayari',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
      {
        code: 1067,
        name: 'Sagua de Tánamo',
        province: {
          name: 'Holguín',
          code: 53,
        },
      },
    ],
  },
  {
    code: 66,
    name: 'Municipio Especial Isla de la Juventud',
    city: [
      {
        code: 1040,
        name: 'Municipio Especial Isla de la Juventud',
      },
    ],
  },
  {
    code: 62,
    name: 'Sancti Spiritus',
    city: [
      {
        code: 1059,
        name: 'Trinidad',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1062,
        name: 'Fomento',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1063,
        name: 'Jatibonico',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1064,
        name: 'La Sierpe',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1065,
        name: 'Cabaiguan',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1147,
        name: 'Yaguajay',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1148,
        name: 'Taguasco',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
      {
        code: 1061,
        name: 'Sancti Spíritus',
        province: {
          name: 'Sancti Spiritus',
          code: 62,
        },
      },
    ],
  },
  {
    code: 61,
    name: 'Matanzas',
    city: [
      {
        code: 1050,
        name: 'Matanzas',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1052,
        name: 'Perico',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1053,
        name: 'Jovellanos',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1054,
        name: 'Pedro Betancourt',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1055,
        name: 'Limonar',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1056,
        name: 'Union de Reyes',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1057,
        name: 'Jaguey Grande',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1058,
        name: 'Los Arabos',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1051,
        name: 'Colón',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1184,
        name: 'Ciénaga de Zapata',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1185,
        name: 'Martí',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1179,
        name: 'Cárdenas',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
      {
        code: 1041,
        name: 'Calimete',
        province: {
          name: 'Matanzas',
          code: 61,
        },
      },
    ],
  },
];
